import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk } from "../../lib/index";
import { FOLDERS } from "../doseeData/utils/Utils";
import { usePlugImageContext } from "../../context/PlugImageContext";
import { getOnePlugImage } from "../../lib/sysNavigation/SysNavigation";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FiImage, FiInfo } from "react-icons/fi";

const Edit = () => {
  const { updatePlugImageState, updatePlugImage } = usePlugImageContext();
  const plugImage = getOnePlugImage();

  const [thumbnail, setThumbnail] = useState(plugImage?.photo_url);
  const [thumbnailId, setThumbnailId] = useState(plugImage?.image_cdn_id);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const plug_image_id = plugImage?.plug_image_id;
  const [type, setType] = useState(plugImage?.type);
  const plugImageRoutes = "/plug/image";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOnePlugImageHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnail) {
      responses(true, "Plug Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      type: type,
      photo_url: thumbnail,
      image_cdn_id: thumbnailId,
    };

    const { message, status } = await updatePlugImage(plug_image_id, data);

    if (status === codeOk) {
      updatePlugImageState({ plug_image_id, ...data });
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={plugImageRoutes}
      eyebrow="Catalog • Plug Images"
      title="Edit Plug Image"
      subtitle="Updated the plug photo and its type label."
      icon={<FiImage className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOnePlugImageHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Recommended 1200×675px, JPG or PNG, under 2MB."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.PLUGS}
        />
      </AddSection>

      <AddSection
        title="Plug Image Details"
        hint="Type names like Type C, Type G — keep them consistent."
        icon={<FiInfo className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InputField
            props={{
              id: "type",
              title: "Type",
              type: "text",
              value: type ? type : "",
              onChange: (e: any) => {
                setType(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
